import { AlertColor, Box } from "@mui/material";
import Modal from "@mui/material/Modal";
import { GridRowParams } from "@mui/x-data-grid";
import { useState } from "react";

import { ProposalsProps } from "../../pages/ProposalPage";
import { api } from "../../services/api";
import ButtonGeneric from "../ButtonGeneric";
import PreloadButton from "../PreloadButton";
import Toast from "../Toast";
import { ModalSendSavedProposalStyle } from "./styles";

interface Props {
    openSendSavedProposalModal: boolean;
    handleCloseSendSavedProposalModal: () => void;
    selectedRowProposal: GridRowParams["row"];
    setDataProposalsList: (values: ProposalsProps[]) => void;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setLoadingTable: any;
}

function ModalSendSavedProposal({
    openSendSavedProposalModal,
    handleCloseSendSavedProposalModal,
    selectedRowProposal,
    setDataProposalsList,
    setLoadingTable,
}: Props) {
    // toast configs
    const [openToast, setOpenToast] = useState(false);
    function handleCloseToast() {
        setOpenToast(false);
    }
    const [toastRequisitionResult, setToastRequisitionResult] = useState<
        AlertColor | undefined
    >();
    const [textToast, setTextToast] = useState("");

    const [isLoadingButton, setIsLoadingButton] = useState(false);

    function sendSavedProposal() {
        setIsLoadingButton(true);
        api.get(`/proposal/send/${selectedRowProposal.id}`, {})
            .then(() => {
                setOpenToast(true);
                setToastRequisitionResult("success");
                setTextToast("Proposta enviada!");
            })
            .then(() => {
                setTimeout(() => {
                    handleCloseSendSavedProposalModal();
                    setOpenToast(false);
                    setIsLoadingButton(false);
                }, 2000);
            })
            .then(() => {
                setLoadingTable(true);

                api.get("/proposal")
                    .then((response) => {
                        setLoadingTable(false);
                        setDataProposalsList(response.data.response);
                    })
                    .catch((error) => {
                        setOpenToast(true);
                        setToastRequisitionResult("error");
                        setTextToast(error.response.data.message);
                    });
            })
            .catch((error) => {
                setOpenToast(true);
                setToastRequisitionResult("error");
                setTextToast(error.response.data.message);
                setIsLoadingButton(false);
            });
    }

    return (
        <Modal
            open={openSendSavedProposalModal}
            onClose={handleCloseSendSavedProposalModal}
        >
            <ModalSendSavedProposalStyle>
                <Box>
                    <p className="topModalText">Deseja enviar a proposta?</p>
                    <form name="editFormModal">
                        <div className="buttonsContainer">
                            <ButtonGeneric
                                onclick={() => {
                                    handleCloseSendSavedProposalModal();
                                }}
                                buttonColor="var(--cancel)"
                                text="CANCELAR"
                            />
                            <PreloadButton
                                colorText="white"
                                background={
                                    selectedRowProposal.implementation
                                        ?.is_active === 1
                                        ? `var(--delete)`
                                        : `var(--confirm)`
                                }
                                loading={isLoadingButton}
                                text="Confirmar"
                                type="submit"
                                onClick={() => {
                                    sendSavedProposal();
                                }}
                                sx={{ minWidth: "140px" }}
                            />
                        </div>
                    </form>
                    <Toast
                        open={openToast}
                        onClose={() => handleCloseToast()}
                        severity={toastRequisitionResult}
                        text={textToast}
                    />
                </Box>
            </ModalSendSavedProposalStyle>
        </Modal>
    );
}
export default ModalSendSavedProposal;
